import projectsActions from './actions';
import { ProjectsState } from './types';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ProjectsState = {
  projects: [],
  projectsError: null,
  projectsLoading: false,
  projectsIsEmpty: false,
};

export const projectsSlice = createSlice({
  initialState,
  name: 'projects',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(projectsActions.getProjects.pending, (state) => {
      state.projectsLoading = true;
    });

    builder.addCase(projectsActions.getProjects.fulfilled, (state, { payload: { projects } }) => {
      state.projects = projects;
      state.projectsError = null;
      state.projectsLoading = false;
      state.projectsIsEmpty = !!!projects.length;
    });

    builder.addCase(projectsActions.getProjects.rejected, (state, { error }) => {
      state.projectsLoading = false;
      state.projectsError = error;
    });
  },
});

export default projectsSlice.reducer;
